import {AuthModel} from './_models'
import {isOnPremisesInstallation} from './onPremisesAccess'
import {ISUN_COMPANY_ID} from './postLoginPath'
import {staffCan} from './staffAccess'

type IsunReportUser = Partial<Pick<AuthModel, 'rl' | 'staff' | 'cpi' | 'isOnPremises'>>

/**
 * Staff granted «گزارش‌ها» follow Isun's report from whatever business is selected, under the name «آیسان» (the
 * user, 2026-10-08). Support sessions are never staff, so they open it only from Isun's business.
 */
export const isIsunReportAdministrator = (user?: IsunReportUser | null): boolean =>
  staffCan(user, 'reports')

/**
 * Isun's own users (its business selected) and staff granted «گزارش‌ها» open the Isun report. Isun is ASA's
 * own customer, so an on-premises install has no such report (the user, 1405/07/25).
 */
export const canViewIsunReport = (user?: IsunReportUser | null): boolean =>
  !isOnPremisesInstallation(user) &&
  (user?.cpi === ISUN_COMPANY_ID || isIsunReportAdministrator(user))
